import React from "react";
import AlertIcon from "components/icons/AlertIcon";
import { useTranslation } from "react-i18next";
import s from "./styles";
import Loading from "components/common/loading";

function CardInfo({ title, data, loading }) {
  const { t } = useTranslation();

  return (
    <s.Container
      style={{
        marginBottom: "36px",
        display: "flex",
        flexDirection: "column",
        height: "auto",
        minHeight: "200px",
        width: "100%",
        overflow: "hidden",
        boxShadow: "0px 4px 24px rgba(0, 0, 0, 0.06)",
      }}
    >
      <s.Title>{title}</s.Title>

      {loading ? (
        <Loading height="100%" size="middle" />
      ) : (
        <s.BodyContainer>
          {data.map((item, i) => (
            <React.Fragment key={i}>
              <s.items>
                <s.text>
                  {item.name} {item.lastName}
                </s.text>
                <s.text>{item.value}</s.text>
              </s.items>
              <s.Line />
            </React.Fragment>
          ))}

          {(!data || data.length === 0) && (
            <s.NoItemsContainer>
              <s.NoItemsMessageCenter>
                <AlertIcon style={{ display: "block", marginBottom: "7px" }} />
                {t("general.noData")}
              </s.NoItemsMessageCenter>
            </s.NoItemsContainer>
          )}
        </s.BodyContainer>
      )}
    </s.Container>
  );
}

export default CardInfo;
